import {
	ChangeDetectionStrategy,
	Component,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { Observable, Subscription } from 'rxjs';

const NUM_STEPS = 3;

@Component({
	selector: 'app-welcome-modal',
	templateUrl: './welcome-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class WelcomeModalComponent implements OnInit, OnDestroy {
	public currentStep = 1;
	public numSteps = NUM_STEPS;
	public userIsAdmin: boolean;
	private userIsAdminSubscription: Subscription;

	@Select(BusinessUsersState.isLoggedInUserAdmin)
	public userIsAdmin$: Observable<boolean>;
	constructor(private dialogRef: MatDialogRef<WelcomeModalComponent>) {}

	ngOnInit(): void {
		this.userIsAdminSubscription = this.userIsAdmin$.subscribe((isAdmin) => {
			this.userIsAdmin = isAdmin;
		});
	}

	public nextStep(): void {
		if (this.currentStep < NUM_STEPS) {
			//Skip step 2 if user is not an admin
			if (this.currentStep == 1 && !this.userIsAdmin) {
				this.currentStep++;
			}
			this.currentStep++;
		} else {
			localStorage.setItem('dismissed-closer-sync-welcome-modal', 'true');
			this.dialogRef.close();
		}
	}

	public closeModal(): void {
		this.dialogRef.close();
	}

	ngOnDestroy(): void {
		this.userIsAdminSubscription?.unsubscribe();
	}
}
